import React, {useState, useEffect, useRef} from "react";
import {useDispatch} from "react-redux";

import {useReduxData} from "../../customHooks/useContextReduxData";
import tooltipHOC from "../../../components/tooltipHOC";
import hintModeTooltipHOC from "../../onboarding/hintModeTooltipHOC";


const FloatingMenuImageContainer = tooltipHOC( //hint on hover
    hintModeTooltipHOC( //hint in hintMode
        ({id, styles}) => <div className="floating-menu-item" id={`floating-menu-item-${id}`} style={styles}/>
    ), undefined, {direction: "right", padding: "10px"}
);


export default function ({
    id,
    name,
    color,
    image,
    body,
    title,
    floatingMenuItemRerenderSign,
    sliderPurpose,
    sliderType,
    hintModeKey,
    tooltipContent
}) {
    const {getShouldFloatingMenuItemDisabled, openedMenuItemNumber} = useReduxData();
    const shouldFloatingMenuItemDisabled = getShouldFloatingMenuItemDisabled(name, sliderPurpose, sliderType);

    const dispatch = useDispatch();

    const [bodyOverflowX, setBodyOverflowX] = useState("0px");
    const [bodyOverflowY, setBodyOverflowY] = useState("0px");
    const [isPositionRecalculated, setIsPositionRecalculated] = useState(false); //used to prevent body render before useEffect
    const [shouldResetPosition, setShouldResetPosition] = useState(false); //on add/delete emoji item should be rerendered

    const bodyRef = useRef(null);

    useEffect(() => {
        const body = bodyRef?.current?.getBoundingClientRect();
        if (body?.right > document.body.clientWidth && !shouldResetPosition) {
            setBodyOverflowX(`${-body.width}px + ${-(108 / 16)}rem`);
        } else if (bodyOverflowX !== "1.875rem") {
            setBodyOverflowX("1.875rem");
        }

        if (body?.bottom >= document.body.clientHeight && !shouldResetPosition) {
            setBodyOverflowY(document.body.clientHeight - body?.bottom + "px");
        } else {
            setBodyOverflowY("0px");
        }

        setIsPositionRecalculated(true);
        if (+openedMenuItemNumber !== +id) {
            setIsPositionRecalculated(false);
        }

        if (shouldResetPosition) {
            setShouldResetPosition(false);
        }
    }, [openedMenuItemNumber === id, shouldResetPosition]);

    useEffect(() => {
        function shouldUpdate () {
            setShouldResetPosition(true);
        }
        setTimeout(shouldUpdate, 1000);
    }, [floatingMenuItemRerenderSign]);

    const changeBodyVisibility = event => (openedMenuItemNumber !== id
        || [`floating-menu-item-${id}`, `floating-menu-item-wrapper-${id}`].includes(event.target.id)
    ) && dispatch({type: "openedMenuItemNumber", value: openedMenuItemNumber !== id ? id : "-1"});

    const highlight = (openedMenuItemNumber === id && body) ? " floating-menu-item-wrapper-active" : "";
    const disabled = shouldFloatingMenuItemDisabled ? " disabled" : "";
    const pointerEvents = shouldFloatingMenuItemDisabled ? " none" : "auto";

    //Attention: floating-menu-item-wrapper class should be the first
    return <div
        className={`floating-menu-item-wrapper${highlight}${disabled}`}
        id={"floating-menu-item-wrapper-" + id}
        style={{backgroundColor: color, pointerEvents: pointerEvents}}
        onClick={changeBodyVisibility}
    >
        <FloatingMenuImageContainer
            id={id}
            hintModeKey={hintModeKey}
            tooltipContent={tooltipContent}
            styles={{backgroundImage: `url(${image})`}}
        />
        {openedMenuItemNumber === id && body && !shouldFloatingMenuItemDisabled && <div
            className="floating-menu-item-body"
            id={`floating-menu-item-body-${id}`}
            ref={bodyRef}
            style={{
                marginLeft: `calc(1.875rem + ${+id % 2 === 0 ? "3.125rem" : "0px"} + ${bodyOverflowX})`,
                marginTop: `calc(-2.5rem + ${bodyOverflowY})`,
                opacity: isPositionRecalculated ? 1 : 0
            }}
        >{title ? <p className="floating-menu-item-title">{title}</p> : undefined}{body}</div>}
    </div>;
}
